
import { component } from '@/helpers/vueTyped';

interface LocalBackgroundProps {
  imageURL: string;
}

export default component<LocalBackgroundProps>()({
  name: 'LocalBackground',

  props: {
    imageURL: {},
  },

  computed: {
    style(): string {
      return this.imageURL ? `background-image: url('${this.imageURL}');` : '';
    },
  },

  render() {
    return(
      <div class='bg-container'>
        <div class='bg-image' style={this.style} />
        <div class='bg-shadow'>
          {this.$slots.shadow}
        </div>
      </div>
    );
  },
});

// VUE JSX HOT LOADER //
if (module.hot) require("/github/workspace/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-2fb18c52/LocalBackground.vue" });